/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Chart_PredictionInputs */

const en_us2_stats_chart_prediction = /** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projection`)
};

const es_es2_stats_chart_prediction = /** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyección`)
};

const ru_stats_chart_prediction = /** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прогноз`)
};

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const id_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const ms_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const da_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const de_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const es_mx2_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const fil_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const fr_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const it_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const hu_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const nl_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const no_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const pl_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const pt_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const pt_br2_stats_chart_prediction = pt_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const ro_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const fi_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const sv_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const vi_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const tr_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const cs_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const bg_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const uk_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const ar_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const hi_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const th_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const ja_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const zh_cn2_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const zh_hant1_stats_chart_prediction = en_us2_stats_chart_prediction;

/** @type {(inputs: Stats_Chart_PredictionInputs) => LocalizedString} */
const ko_stats_chart_prediction = en_us2_stats_chart_prediction;

/**
* | output |
* | --- |
* | "Projection" |
*
* @param {Stats_Chart_PredictionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_chart_prediction = /** @type {((inputs?: Stats_Chart_PredictionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Chart_PredictionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_chart_prediction(inputs)
	if (locale === "ms") return ms_stats_chart_prediction(inputs)
	if (locale === "da") return da_stats_chart_prediction(inputs)
	if (locale === "de") return de_stats_chart_prediction(inputs)
	if (locale === "en-US") return en_us2_stats_chart_prediction(inputs)
	if (locale === "es-ES") return es_es2_stats_chart_prediction(inputs)
	if (locale === "es-MX") return es_mx2_stats_chart_prediction(inputs)
	if (locale === "fil") return fil_stats_chart_prediction(inputs)
	if (locale === "fr") return fr_stats_chart_prediction(inputs)
	if (locale === "it") return it_stats_chart_prediction(inputs)
	if (locale === "hu") return hu_stats_chart_prediction(inputs)
	if (locale === "nl") return nl_stats_chart_prediction(inputs)
	if (locale === "no") return no_stats_chart_prediction(inputs)
	if (locale === "pl") return pl_stats_chart_prediction(inputs)
	if (locale === "pt-BR") return pt_br2_stats_chart_prediction(inputs)
	if (locale === "pt") return pt_stats_chart_prediction(inputs)
	if (locale === "ro") return ro_stats_chart_prediction(inputs)
	if (locale === "fi") return fi_stats_chart_prediction(inputs)
	if (locale === "sv") return sv_stats_chart_prediction(inputs)
	if (locale === "vi") return vi_stats_chart_prediction(inputs)
	if (locale === "tr") return tr_stats_chart_prediction(inputs)
	if (locale === "cs") return cs_stats_chart_prediction(inputs)
	if (locale === "bg") return bg_stats_chart_prediction(inputs)
	if (locale === "ru") return ru_stats_chart_prediction(inputs)
	if (locale === "uk") return uk_stats_chart_prediction(inputs)
	if (locale === "ar") return ar_stats_chart_prediction(inputs)
	if (locale === "hi") return hi_stats_chart_prediction(inputs)
	if (locale === "th") return th_stats_chart_prediction(inputs)
	if (locale === "ja") return ja_stats_chart_prediction(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_chart_prediction(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_chart_prediction(inputs)
	return ko_stats_chart_prediction(inputs)
});
export { stats_chart_prediction as "stats.chart.prediction" }